import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Modal,
  ModalBody
} from "reactstrap";
import './style.scss';

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'

import Loader from "../../components/Loader";
import { get, put } from '../../helpers/api_helper';
import { toast } from 'react-toastify';
import { AvField, AvForm } from 'availity-reactstrap-validation';
const { io } = require("socket.io-client");

const Setting = props => {
  const { user } = props;
  const [loading, setLoading] = useState(false);
  const [isShop, setIsShop] = useState(undefined);
  const [isMaintain, setIsMaintain] = useState(undefined);
  const [isStory, setIsStory] = useState(undefined);
  const [autoRam, setAutoRam] = useState(undefined);
  const [isPopup, setIsPopup] = useState(undefined);
  const [raamJaap, setRaamJaap] = useState(undefined);
  const [dohaNoti, setDohaNoti] = useState(undefined);
  const [poojaNoti, setPoojaNoti] = useState(undefined);
  const [socket, setSocket] = useState(undefined);
  const [isLoginMand, setIsLoginMand] = useState(undefined);
  const [raamWinner, setRaamWinner] = useState(undefined);
  const [error, setError] = useState(false);
  const [notiConfigModal, setNotiConfigModal] = useState(false);
  const [raamNotiData, setRaamNotiData] = useState(undefined);

  useEffect(() => {
    if (user)
      getSettings();
  }, [user]);

  const getSettings = () => {
    get('/setting', { token: user?.token })
      .then(res => {
        if (res?.statusCode == 200) {
          setIsShop(res?.data?.shop);
          setIsMaintain(res?.data?.maintinance);
          setIsStory(res?.data?.story);
          setAutoRam(res?.data?.autoRam);
          setIsPopup(res?.data?.isPopup);
          setRaamJaap(res?.data?.raamNoti);
          setDohaNoti(res?.data?.dohaNoti);
          setPoojaNoti(res?.data?.poojaNoti);
          setIsLoginMand(res?.data?.login);
          setRaamWinner(res?.data?.raamWinner);
          setRaamNotiData(res?.data?.raamNotiData);
        } else {
          toast.error(res?.error);
          setError(true);
        }
      })
      .catch(err => {
        console.log('error while getting setting', err);
        toast.error("" + err);
      });

    const socket = io(Utils.API_URL + "/ram", { transports: ["websocket"], upgrade: false });
    socket.on("get", (res) => {
      // console.log('socket on list', res);
      if (res?.statusCode == 200) {
        // console.log(res?.data)
        // setData(res?.data);
      }
    });
    socket.on("connect", (socket2) => {
      console.log('socket connect', socket2);
      // socket.emit("auto", { auth: user?.token, switch: true });
    });
    setSocket(socket);
  }

  const handleChangeToggle = (val, to) => {
    console.log('changing toggle', val, typeof val)
    const body = {
      [to]: !val,
      token: user?.token
    }
    put("/setting/update", body)
      .then(res => {
        if (res?.statusCode == 200) {
          toast.success(res?.message);
          setIsShop(res?.data?.shop);
          setIsMaintain(res?.data?.maintinance);
          setIsStory(res?.data?.story);
          setAutoRam(res?.data?.autoRam);
          setIsPopup(res?.data?.isPopup);
          setRaamJaap(res?.data?.raamNoti);
          setDohaNoti(res?.data?.dohaNoti);
          setPoojaNoti(res?.data?.poojaNoti);
          setIsLoginMand(res?.data?.login);
          setRaamWinner(res?.data?.raamWinner);
          if (to == 'autoRam')
            socket.emit("auto", { auth: user?.token, switch: res?.data?.autoRam });
        }
        else
          toast.error(res?.error);
      })
      .catch(err => {
        console.log('error whiling setting setting', err);
        toast.error(err + "");
      })
  }

  const handleConfig = (type) => {
    setNotiConfigModal(true);
  }

  const handleValidSubmit = (e, v) => {
    const body = {
      raamNotiData: v,
      token: user?.token
    }
    put("/setting/update", body)
      .then(res => {
        if (res?.statusCode == 200) {
          setRaamNotiData(res?.data?.raamNotiData);
          setNotiConfigModal(false);
        } else {
          toast.error(res?.error);
        }
      })
      .catch(err => {
        console.log('error while updating raam noti data', err);
        toast.error('Something Went Wrong!');
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Settings" />
        <Modal className="modal_form" isOpen={notiConfigModal} centered={true}>
          <ModalBody className="py-3 px-5">
            <h5 className="text-black font-size-20">{'Configure Raam Naam Notification'}</h5>
            <div className="p-2">
              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v)
                }}
              >
                <Row>
                  <Col lg={12} md={12}>
                    <div className="mb-3 mt-2">
                      <AvField
                        name="title"
                        label="Notification Title"
                        className="form-control"
                        placeholder="Enter something about your notification"
                        type="text"
                        required
                        value={raamNotiData?.title}
                      // validate={{min:{value:1}}}
                      />
                    </div>
                  </Col>
                  <Col lg={12} md={12}>
                    <div className="mb-3 mt-2">
                      <AvField
                        name="body"
                        label="Notification Description"
                        className="form-control"
                        placeholder="Enter detailed notification"
                        type="textarea"
                        rows={4}
                        required
                        value={raamNotiData?.body}
                      // validate={{min:{value:1}}}
                      />
                    </div>
                  </Col>
                  <Col lg={12} md={12}>
                    <div className="mt-4">
                      <Row>
                        <Col md={6}>
                          <button
                            className="btn btn-primary w-100 waves-effect waves-light"
                            style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                            onClick={() => { setNotiConfigModal(false); }}
                            type="reset"
                          >
                            Cancel
                          </button>
                        </Col>
                        <Col md={6}>
                          <button
                            className="btn btn-primary w-100 waves-effect waves-light"
                            type="submit"
                            style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                          >
                            Update
                          </button>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </AvForm>
            </div>
          </ModalBody>
        </Modal>
        {!error &&
          <Row>
            <Col lg={4} md={4}>
              <Card>
                <CardBody>
                  <div className='d-flex align-items-center justify-content-between'>
                    <i className='mdi mdi-store' style={{ color: Utils.themeColor, fontSize: 50, marginRight: 20 }} />
                    <span style={{ fontWeight: 'bolder' }}>Shop Store</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        className="toggle-switch-checkbox"
                        name="toggleSwitch"
                        id="shop"
                        onChange={(e) => handleChangeToggle(isShop, 'shop')}
                        checked={isShop}
                      />
                      <label className="toggle-switch-label" htmlFor="shop">
                        <span className="toggle-switch-inner" />
                        <span className="toggle-switch-switch" />
                      </label>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4} md={4}>
              <Card>
                <CardBody>
                  <div className='d-flex align-items-center justify-content-between'>
                    <i className='mdi mdi-cogs' style={{ color: Utils.themeColor, fontSize: 50, marginRight: 20 }} />
                    <span style={{ fontWeight: 'bolder' }}>Maintinance</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        className="toggle-switch-checkbox"
                        name="toggleSwitch"
                        id="maintinance"
                        onChange={(e) => handleChangeToggle(isMaintain, 'maintinance')}
                        checked={isMaintain}
                      />
                      <label className="toggle-switch-label" htmlFor="maintinance">
                        <span className="toggle-switch-inner" />
                        <span className="toggle-switch-switch" />
                      </label>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4} md={4}>
              <Card>
                <CardBody>
                  <div className='d-flex align-items-center justify-content-between'>
                    <i className='mdi mdi-music-box' style={{ color: Utils.themeColor, fontSize: 50, marginRight: 20 }} />
                    <span style={{ fontWeight: 'bolder' }}>Stories</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        className="toggle-switch-checkbox"
                        name="toggleSwitch"
                        id="story"
                        onChange={(e) => handleChangeToggle(isStory, 'story')}
                        checked={isStory}
                      />
                      <label className="toggle-switch-label" htmlFor="story">
                        <span className="toggle-switch-inner" />
                        <span className="toggle-switch-switch" />
                      </label>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4} md={4}>
              <Card>
                <CardBody>
                  <div className='d-flex align-items-center justify-content-between'>
                    <i className='mdi mdi-notification-clear-all' style={{ color: Utils.themeColor, fontSize: 50, marginRight: 20 }} />
                    <span style={{ fontWeight: 'bolder' }}>Auto Ram Naam</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        className="toggle-switch-checkbox"
                        name="toggleSwitch"
                        id="autoRam"
                        onChange={(e) => handleChangeToggle(autoRam, 'autoRam')}
                        checked={autoRam}
                      />
                      <label className="toggle-switch-label" htmlFor="autoRam">
                        <span className="toggle-switch-inner" />
                        <span className="toggle-switch-switch" />
                      </label>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4} md={4}>
              <Card>
                <CardBody>
                  <div className='d-flex align-items-center justify-content-between'>
                    <i className='mdi mdi-clipboard' style={{ color: Utils.themeColor, fontSize: 50, marginRight: 20 }} />
                    <span style={{ fontWeight: 'bolder' }}>Welcome Popup</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        className="toggle-switch-checkbox"
                        name="toggleSwitch"
                        id="popup"
                        onChange={(e) => handleChangeToggle(isPopup, 'isPopup')}
                        checked={isPopup}
                      />
                      <label className="toggle-switch-label" htmlFor="popup">
                        <span className="toggle-switch-inner" />
                        <span className="toggle-switch-switch" />
                      </label>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4} md={4}>
              <Card>
                <CardBody>
                  <div className='d-flex align-items-center justify-content-between'>
                    <i className='mdi mdi-bell' style={{ color: Utils.themeColor, fontSize: 50, marginRight: 20 }} />
                    <span style={{ fontWeight: 'bolder' }}>Ram Naam Notification</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        className="toggle-switch-checkbox"
                        name="toggleSwitch"
                        id="raamJaap"
                        onChange={(e) => handleChangeToggle(raamJaap, 'raamNoti')}
                        checked={raamJaap}
                      />
                      <label className="toggle-switch-label" htmlFor="raamJaap">
                        <span className="toggle-switch-inner" />
                        <span className="toggle-switch-switch" style={{ height: 24 }} />
                      </label>
                      <Button onClick={() => handleConfig("raamNoti")}
                        title={"Edit"}
                        style={{ backgroundColor: Utils.themeColor, float: 'right', width: 40, height: 40, marginTop: 3, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4} md={4}>
              <Card>
                <CardBody>
                  <div className='d-flex align-items-center justify-content-between'>
                    <i className='mdi mdi-bell' style={{ color: Utils.themeColor, fontSize: 50, marginRight: 20 }} />
                    <span style={{ fontWeight: 'bolder' }}>Doha Notification</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        className="toggle-switch-checkbox"
                        name="toggleSwitch"
                        id="dohaNoti"
                        onChange={(e) => handleChangeToggle(dohaNoti, 'dohaNoti')}
                        checked={dohaNoti}
                      />
                      <label className="toggle-switch-label" htmlFor="dohaNoti">
                        <span className="toggle-switch-inner" />
                        <span className="toggle-switch-switch" />
                      </label>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4} md={4}>
              <Card>
                <CardBody>
                  <div className='d-flex align-items-center justify-content-between'>
                    <i className='mdi mdi-bell' style={{ color: Utils.themeColor, fontSize: 50, marginRight: 20 }} />
                    <span style={{ fontWeight: 'bolder' }}>Pooja Notification</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        className="toggle-switch-checkbox"
                        name="toggleSwitch"
                        id="poojaNoti"
                        onChange={(e) => handleChangeToggle(poojaNoti, 'poojaNoti')}
                        checked={poojaNoti}
                      />
                      <label className="toggle-switch-label" htmlFor="poojaNoti">
                        <span className="toggle-switch-inner" />
                        <span className="toggle-switch-switch" />
                      </label>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4} md={4}>
              <Card>
                <CardBody>
                  <div className='d-flex align-items-center justify-content-between'>
                    <i className='mdi mdi-login' style={{ color: Utils.themeColor, fontSize: 50, marginRight: 20 }} />
                    <span style={{ fontWeight: 'bolder' }}>Login Mandatory</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        className="toggle-switch-checkbox"
                        name="toggleSwitch"
                        id="login"
                        onChange={(e) => handleChangeToggle(isLoginMand, 'login')}
                        checked={isLoginMand}
                      />
                      <label className="toggle-switch-label" htmlFor="login">
                        <span className="toggle-switch-inner" />
                        <span className="toggle-switch-switch" />
                      </label>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4} md={4}>
              <Card>
                <CardBody>
                  <div className='d-flex align-items-center justify-content-between'>
                    <i className='mdi mdi-gift' style={{ color: Utils.themeColor, fontSize: 50, marginRight: 20 }} />
                    <span style={{ fontWeight: 'bolder' }}>Raam Naam Winner</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        className="toggle-switch-checkbox"
                        name="toggleSwitch"
                        id="raamWinner"
                        onChange={(e) => handleChangeToggle(raamWinner, 'raamWinner')}
                        checked={raamWinner}
                      />
                      <label className="toggle-switch-label" htmlFor="raamWinner">
                        <span className="toggle-switch-inner" />
                        <span className="toggle-switch-switch" />
                      </label>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        }
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  return { user }
}

export default withRouter(
  connect(mapStatetoProps, {})(Setting)
)
